import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FeatureService } from '../service/feature.service';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { HospitalService } from 'src/app/hospital-section/hospital.service';
import { take } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {
  featureArr: any[] = [];
  featureData: any;
  token: string;
  createInput: string = '';
  selectedItems: string[] = [];
  date4: Date = null;
  editData: FormGroup;
  featureId: any;
  featureDataa: FormGroup;
  selectedValue: string = '';
  selectedV: any;
  page: number = 1;
  hosdata: any;
  hosDataId:any;
  allClinic: any;
  selectedHosid: any;
  constructor(private featureService: FeatureService, private authService: AuthService, private hospitalservice: HospitalService) { }
  @ViewChild("closemodal", { static: false }) cref!: ElementRef;
  @ViewChild("closeupdateModal", { static: false }) href!: ElementRef;


  clinics = [
    { value: 'Al-shifa clinic'},
    { value: 'Family health care'},
    { value: 'Test Clinic'}
  ]
  checkboxItems = [
    { value: 'clinic' },
    { value: 'hospital' },
  ];
  ngOnInit() {
    this.date4 = new Date();
    this.authService.authDataSubject.pipe(take(1)).subscribe((authData) => {
      this.token = authData._token;
      console.log(authData._token);
    });
    this.featureDataa = new FormGroup({
      type: new FormControl(null, Validators.required),
    })
    this.getFeature();
    this.getClinics();
    console.log(this.hosDataId);
  }

  onSelectChange(event: any) {
    console.log('Selected value:', event.target.value);
    this.selectedV = event.target.value
    this.getData();
  }

  getClinics(){
    this.featureService.getClinic(this.token).subscribe((res:any) =>{
      console.log(res);
      this.allClinic = res.data
    })
  }

  selectHos(event:any){
    console.log(event.target.value);
    this.selectedHosid = event.target.value;
  }

  getData() {
    if (this.selectedV === 'clinic') {
      console.log("this is in clinic side")
    } else if (this.selectedV === 'hospital') {
      console.log("this is in hospital side")
      this.hospitalservice.getHospitals(this.token, this.page).subscribe((res: any) => {
        console.log(res);
        this.hosdata = res.patData
      })
    }
  }

  createFeature() {
    const payload = {
      type: this.createInput,
      date: this.date4
    }
    console.log(payload);
    this.featureService.creatProduct(payload).subscribe((res: any) => {
      console.log(res, "created Successfully");
    })
    this.getFeature();
    this.cref.nativeElement.click();
    this.createInput = '';
  }

  selectProduct(event:any){
    console.log(event.target.value);
    if (event.target.value) {
      if (this.selectedItems.includes(event.target.value)) {
        this.selectedItems.splice(this.selectedItems.indexOf(event.target.value), 1);
      } else {
        this.selectedItems.push(event.target.value);
      } 
      console.log("this is selected Item", this.selectedItems);  
    }
  }

  addFeatureHospital(){
    let payload = {
      hospitalId : this.selectedHosid,
      features : this.selectedItems
    }
    this.featureService.addFeature(this.token,payload).subscribe((res:any) =>{
      console.log(res);
    })
  }

  getFeature() {
    this.featureService.getFeatures(this.token).subscribe((res: any) => {
      this.featureData = res.docs;
      console.log("this is response from feature side ", this.featureData);
    }, (error) => {
      console.log("Error : ", error);
    })
  }

  geteditFeature(data: any) {
    console.log(data);
    this.featureDataa = new FormGroup({
      type: new FormControl(data.type, Validators.required),
      _id: new FormControl(data._id, Validators.required)
    });
  }

  editFeature(data: any) {
    this.featureService.updateProduct(data._id, data).subscribe((res: any) => {
      console.log("successfully Updated");
      this.featureDataa.reset;
      this.getFeature();
      this.href.nativeElement.click();
    })
  }

  deletFeature(data: any) {
    console.log(data);
    this.featureService.deletDocument(data._id).subscribe((res: any) => {
      console.log("successfully deleted");
      this.getFeature();
    })
  }
}